'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleStoreMessagesCookie = undefined;

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var _createPostMessageAction = require('./createPostMessageAction');

var handleStoreMessagesCookie = exports.handleStoreMessagesCookie = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.STORE_MESSAGES_COOKIE);


//////////////////
// WEBPACK FOOTER
// ./js/post-message/actions/handleStoreMessagesCookie.js
// module id = 223
// module chunks = 2 3